module.exports = __webpack_public_path__ + "static/img_family_photo-a5169c1bc4e7e80b73f5b5936d28f703.webp";